/*
  環境変数定義（レビューサーバー用）
  © 2021 Digital Information Technologies Corporation. All Rights Reserved.
  @author Digital Information Technologies Corporation
  @module src/constants/sysconfig.rev.ts
*/

/*
  環境変数定義（レビューサーバー用）
  環境固有の環境変数を定義する。
  当ファイルの定義値で、sysconfig.tsを上書きする。
  @class src:constants:sysconfig.rev
  @static
*/

const sysconfig = {
  // 共通
  common: {
    // 開発モード
    devmode: false,
  },

  analysis: {
    endpointUrl: "https://bgdlaoivq5.execute-api.ap-northeast-1.amazonaws.com",
    envPath: "stg",
    oldAnalysisApiUse: false,
  },

  // ３分初期作成業種切替
  siteinit: {
    // 旧業種を利用する代理店
    oldBizCat: {
      shopcodes: [
        "0005", // 株式会社LIXIL住生活ソリューション
        "0008", // GoodLiving友の会
        "0011", // ホームページ作成パッケージ
        "0048", // キヤノンマーケティングジャパン株式会社
        "0109", // アイ・モバイル株式会社 スタッフアカウント
        "0110", // アイ・モバイル株式会社 社内共有・サンプルサイト
        "0121", // アイ・モバイル システム開発部
        "0123", // アイ・モバイル株式会社 テンプレート管理
      ],
    },
  },

  logs: {
    endpointUrl: "https://dc532sz925.execute-api.ap-northeast-1.amazonaws.com",
    envPath: "stg",
    oldAnalysisApiUse: true,
    openKey: "im",
  },

  recommend: {
    endpointUrl: "/support/recommend",
  },

  profile: {
    endpointUrl: "/support/profilesetting",
  },

  // 業種別化粧
  makeupTargetIndustry: {
    targetClientCode: [
      "1003", // 建設・建築・土木業
      "1004", // 製造業
      "1015", // 介護業・福祉業
    ],
    targetClientName: {
      1003: "common_code_member_industry_construction", // 建設・建築・土木業
      1004: "common_code_common_industry_manufacturing", // 製造業
      1015: "common_code_member_industry_nursingCareAndWelfare", // 介護業・福祉業
    },
  },

  // Google Analyticsの設定
  googleAnalytics: {
    // Google AnalyticsのトラッキングID
    trackingId: "G-BN7B6DXCJL",
  },
};

export default sysconfig;
